package fr.arcplex.sooner

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import fr.arcplex.network.model.CoherenceFilmInfo
import fr.arcplex.network.model.ScreenKind
import fr.arcplex.network.logging.Logger
import fr.arcplex.network.model.ItemAction
import fr.arcplex.network.model.RailItem
import fr.arcplex.sooner.infrastructure.PageManager
import fr.arcplex.sooner.ui.theme.SoonerTheme
import fr.arcplex.sooner.webui.CoherenceFilmInfoView
import fr.arcplex.sooner.webui.CoherenceSplashView
import fr.arcplex.sooner.webui.FilmInfoView
import fr.arcplex.sooner.webui.PageView
import fr.arcplex.sooner.webui.SplashView
import fr.arcplex.sooner.getPlatformUtils

@Composable
fun App(pageManager: PageManager) {
    MaterialTheme {
        val currentPage = pageManager.currentPage
        val error = pageManager.error
        val isTV = getPlatformUtils().isTV

        fr.arcplex.sooner.ui.theme.SoonerTheme {
            Column(modifier = Modifier.fillMaxSize()) {
                if (!isTV && (pageManager.currentVideo != null || pageManager.canGoBack)) {
                    Row(modifier = Modifier.fillMaxWidth()) {
                        TextButton(onClick = { pageManager.goBack() }) {
                            Text("‹ Back")
                        }
                    }
                }
                if(pageManager.currentVideo != null) {
                    VideoPlayer(
                        url = pageManager.currentVideo!!.url,
                        modifier = Modifier.fillMaxSize(),
                        drmLicenseUrl = pageManager.currentVideo!!.licenceUrl,
                        licensePayload = pageManager.currentVideo!!.payload,
                        drmProvisionUrl = pageManager.currentVideo!!.provisionUrl,
                        vudrmToken = pageManager.currentVideo!!.vudrmToken,
                        onPlay = { Logger.d("VIDEO", "play"); pageManager.onPlaybackStarted() },
                        onPause = { Logger.d("VIDEO", "pause") },
                        onStop = { Logger.d("VIDEO", "stop"); pageManager.onPlaybackStopped(); if (!isTV && pageManager.currentVideo != null) pageManager.goBack() },
                        onSeek = { pos -> Logger.d("VIDEO", "seek: $pos"); pageManager.onPlaybackSeek(pos) },
                        onTick = { pos, dur -> Logger.d("VIDEO", "tick: $pos/$dur") },
                        videoInfo = pageManager.currentVideoInfo
                    )
                } else if (currentPage != null && pageManager.pageKind != ScreenKind.FILM) {
                    PageView(
                        page = currentPage!!,
                        onRailItemClicked = { item -> pageManager.dispatchItemAction(item) },
                        onMenuItemClicked = { item -> pageManager.dispatchItemAction(item) },
                        onSearchQuery = { rail, query, validate ->
                            pageManager.search(rail, query, validate)
                        },
                        isTV = isTV,
                        menuOpen = pageManager.menuOpen,
                        onMenuToggle = { pageManager.toggleMenu() },
                        onMenuDismiss = { pageManager.closeMenu() },
                        coherence = pageManager.isCoherence
                    )
                } else if (currentPage != null && pageManager.pageKind == ScreenKind.FILM) {
                    if (pageManager.isCoherence && pageManager.coherenceFilmInfo != null) {
                        CoherenceFilmInfoView(
                            filmInfo = pageManager.coherenceFilmInfo!!,
                            onRailItemClicked = { id -> pageManager.onFilmSelected(id.toString()) },
                            onActionClicked = { action ->
                                when (action) {
                                    "play" -> {
                                        val railItem = RailItem(
                                            uid = "",
                                            type = "FILM",
                                            content = "",
                                            label = pageManager.coherenceFilmInfo?.contents?.title,
                                            action = ItemAction(
                                                url = "/api/generique/V5/viewVideo?idprog=${pageManager.coherenceFilmInfo?.contents?.ref}&type=FILM"
                                            ),
                                            height = 0f,
                                            width = 0f
                                        )
                                        pageManager.onVideoSelected(railItem)
                                    }
                                    "trailer" -> {}
                                    "wishlist" -> {}
                                }
                            },
                            isTV = isTV,
                            menu = pageManager.coherenceFallbackPage?.menu,
                            onMenuItemClicked = { item -> pageManager.dispatchItemAction(item) },
                            menuOpen = pageManager.menuOpen,
                            onMenuToggle = { pageManager.toggleMenu() },
                            onMenuDismiss = { pageManager.closeMenu() }
                        )
                    } else {
                        FilmInfoView(page = currentPage,
                            onRailItemClicked = { item -> pageManager.dispatchItemAction(item) },
                            onMenuItemClicked = { item -> pageManager.dispatchItemAction(item) },
                            isTV = isTV,
                            menuOpen = pageManager.menuOpen,
                            onMenuToggle = { pageManager.toggleMenu() },
                            onMenuDismiss = { pageManager.closeMenu() }
                            )
                    }
                } else {
                    // Boot screen: covers both the initial load and a startup
                    // failure (with retry) instead of a bare spinner/red text.
                    if (pageManager.isCoherence) {
                        CoherenceSplashView(
                            state = pageManager.bootState,
                            error = pageManager.bootError ?: error,
                            page = currentPage,
                            onRetry = { pageManager.retryBoot() },
                            isTV = isTV
                        )
                    } else {
                        SplashView(
                            state = pageManager.bootState,
                            error = pageManager.bootError ?: error,
                            page = currentPage,
                            onRetry = { pageManager.retryBoot() },
                            isTV = isTV
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun Greeting() {
    // Keep empty as it was used by the default template
}
